import DapDSCommand from './command.component'

export * from './command.component'
export default DapDSCommand

DapDSCommand.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-command': DapDSCommand
  }
}
